import { useEffect, useRef } from 'react'
import { useDispatch, useSelector, shallowEqual } from 'react-redux'
import { Card } from '@leroy-merlin-br/backyard-react-ui'

import { Actions } from 'lmcv/redux/modules/coupon'

import { ListVouchers } from './components/ListVouchers'

const AdvantagesPage = () => {
  const dispatch = useDispatch()
  const { percentage, activated } = useSelector(
    state => state.coupon,
    shallowEqual
  )

  const wrapperRef = useRef(null)

  useEffect(() => {
    wrapperRef.current.scrollIntoView({
      block: 'start',
      behavior: 'smooth'
    })
  }, [])

  useEffect(() => {
    dispatch(Actions.getPercentage(1, 'available', 15))
    dispatch(Actions.getActivated(1, 'advantages', 15))
  }, [dispatch])

  return (
    <Card title="Minhas vantagens" ref={wrapperRef}>
      <ListVouchers vouchers={percentage} vouchersActivated={activated} />
    </Card>
  )
}

export default AdvantagesPage
